import http from "~/common/http";

export const CustomerTrace = {
    id: "",
    customer_id: "",
    product_id: "",
    contact_id: "",
    content: "",
    next_time: "",
};

export default {

    getList(params) {
        return http.get('/api/order-disruption/index', {
            params: params
        });
    },

    getCustomerLog(customer_id) {
        return http.get('/api/order-disruption/customer-log', {
            params: {
                customer_id: customer_id
            }
        });
    },


    getProduct(customer_id) {
        return http.get('/api/order-disruption/get-product', {
            params: {
                customer_id: customer_id
            }
        });
    },

    create(params) {
        return http.post("/api/order-disruption/create", params);
    },

}


// WEBPACK FOOTER //
// ./src/services/OrderDisruption.js